import { Action, ActionWithoutPayload } from "types/redux"
import { PreventionHandoffLink } from "types/store"

import {
  PREVENTION_HANDOFF_CANCEL_REQUEST,
  PREVENTION_HANDOFF_CREATE_REQUEST,
  PREVENTION_HANDOFF_CREATE_SUCCESS,
  PREVENTION_HANDOFF_FAILURE,
  PREVENTION_HANDOFF_SMS_REQUEST,
  PREVENTION_HANDOFF_STATUS_REQUEST,
  PREVENTION_HANDOFF_STATUS_SUCCESS,
  RESET_PREVENTION_HANDOFF,
} from "./constants"

const actions = {
  create: (): ActionWithoutPayload => ({ type: PREVENTION_HANDOFF_CREATE_REQUEST }),
  createSuccess: (link: PreventionHandoffLink): Action<PreventionHandoffLink> => ({
    type: PREVENTION_HANDOFF_CREATE_SUCCESS,
    payload: link,
  }),
  failure: (): ActionWithoutPayload => ({ type: PREVENTION_HANDOFF_FAILURE }),
  fetchStatus: (): ActionWithoutPayload => ({ type: PREVENTION_HANDOFF_STATUS_REQUEST }),
  statusSuccess: (status: string): Action<string> => ({
    type: PREVENTION_HANDOFF_STATUS_SUCCESS,
    payload: status,
  }),
  sendSms: (): ActionWithoutPayload => ({ type: PREVENTION_HANDOFF_SMS_REQUEST }),
  cancel: (): ActionWithoutPayload => ({ type: PREVENTION_HANDOFF_CANCEL_REQUEST }),
  reset: (): ActionWithoutPayload => ({ type: RESET_PREVENTION_HANDOFF }),
}

export default actions
